<template>
    <div class="about" style="background-color: #ffffff;min-height: 100%;">
        <div style="text-align: left;padding-top: 32px;padding-left: 16px;" class="in-bl-line">
            <div style="" class="in-bl-v-m">
              <!-- <van-image
                  round
                  width="83px"
                  height="83px"
                  :src="header_img"
              /> -->
              <img
                  round
                  style="width: 83px;height: 83px;"
                  src="../assets/images/logo.jpg"
                />
            </div>
            <div style="text-align: center;margin-left: 24px;" class="in-bl-v-m" v-if="!isLogin">
              <div style="font-size: 15px;color: #333;line-height: 24px;">登录后享受更多优惠及服务</div><br/>
              <van-button round type="info" style="background: #f25422;border: none;" @click="goLogin">登录/注册</van-button>
            </div>

           <div style="text-align: center;margin-left: 24px;" class="in-bl-v-m">
            <div style="font-size: 16px;color: #f25422;line-height: 24px;font-weight: bold;">{{info.uid}}</div>

            <div style="margin-top: 10px;">
              <van-button @click="loginOut">退出登录</van-button>
              <van-button style="margin-left: 14px;" @click="resetPassword">修改密码</van-button>
            </div>
          </div> 

        </div>

      <div class="barrie-line" style="margin-top: 40px"></div>

        <div   class="form-info-panel" style="padding-left: .4rem;text-align: left;">


          <!-- <div class="cus-row cus-row-v-m" @click="goCommonQue">
            <div class="cus-row-col-4"><span class="input-tag">修改密码</span></div>
            <div class="cus-row-col-8 select-line2">
              <input placeholder="" onfocus="this.blur()" readonly="readonly" class="line-input2">
            </div>
          </div> -->

          <div class="barrie-line" v-if="isLogin && false"></div>

          <div class="cus-row cus-row-v-m" @click="goCommonQue" v-if="isLogin && false">
            <div class="cus-row-col-4"><span class="input-tag">查看历史</span></div>
            <div class="cus-row-col-8 select-line2">
              <input placeholder="" onfocus="this.blur()" readonly="readonly" class="line-input2">
            </div>
          </div>


        </div>


      <tar-bar @showqr="showqr"></tar-bar>


    </div>
</template>

<script>
    import common from '../assets/js/common'
    import addone from '../components/addone'
    import stroe from '../store'
    import TarBar from '../components/TarBar'
    import {Toast} from "vant";

    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        components:
            {
              TarBar
            },
        data: function(){
            return {
                roleCn:'',
                phone:'',
                isLogin: false,
                info: {},
                header_img: '',
               user: {}
            }
        },
        methods:{
            goLogin()
            {
              this.$router.push({path: '/auth'})
            },
            goAbout()
            {
              this.$router.push({path: '/about', query:{type: 'about'}})
            },
            goSafe()
            {
              this.$router.push({path: '/about', query:{type: 'safe_ensure'}})
            },
            goCommonQue()
            {
              this.$router.push({path: 'common_que'})
            },
            initPage:function()
            {
                this.isLogin = common.getAuth()?common.getAuth():''
                //如果登录了，显示登陆后的信息
              console.log('请求网络')
              common.commonHttp('/index/dealer-quali-info',{dealer_id: common.getAuth()},'get').then((res)=>{

                console.log('请求值')
                console.log(res)


                if( res.data.status == 1 )
                {

                  console.log('这里去赋值')
                  console.log(res.data.data)

                  // this.pending_list = res.data.pending_list
                  this.user = res.data.data.dealer
                  this.header_img = this.$common.polishingImg(this.user.header_img)
                }
                Toast.clear()

              }).catch((res=>{
                Toast.clear()
              }));
            },
            loginOut:function()
            {
                common.setAuth('')
                this.$router.push({path: 'auth'})
            },
            resetPassword:function()
            {
                this.$router.push('reset_password')
            }
        },
        created:function()
        {
            /**
             * 如果没有token则跳到登录页哟
             */
            common.checkToken(this)

            common.setTitle('个人中心');
            this.id = common.queryValue('id');
        },
        mounted()
        {
            this.initPage();
        },
        onShow()
        {
        },
        computed:{
        }
    }
</script>

<style scoped>
    .fs-14-fc-ffffff
    {
        color: #ffffff;;
        font-size: 0.4375rem;
        font-family: PingFangSC-Medium;
        line-height: 0.525rem;
    }
</style>
